import apiProcess from "../../../api/utility";
import { getD2DResultInfo, getD2DResultCurve, getComplianceResult } from "../../../api/Rocky/d2d";
import WaveformResultHelper from '@/services/Rocky/result/helper/WaveformResultHelper';

function getD2DResultInfoPromise(d2dChannelId, option) {
  return new Promise((resolve, reject) => {
    getD2DResultInfo({ d2dChannelId, option }).then(res => {
      if (res.data) {
        resolve(res.data);
      } else {
        reject(null);
      }
    }, error => {
      reject(null);
    })
  })
}

function getD2DResultCurvePromise(params) {
  return apiProcess(getD2DResultCurve, params)
}

function getD2DComplianceResultPromise({ componentName, pinName, signal, option, d2dChannelId, fileName }) {
  return apiProcess(getComplianceResult, { componentName, pinName, option, d2dChannelId, fileName }, false, false, true, false)
}

export {
  getD2DResultInfoPromise,
  getD2DResultCurvePromise,
  getD2DComplianceResultPromise,
}